const mapInit = () => {
}
export default mapInit



// WEBPACK FOOTER //
// ./src/js/customs/google/MapGoogle.js